import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../config/app-settings';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private formHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
  };

  constructor(private http: HttpClient) {}

  createPaymentCustomer(companyId: number): Observable<any> {
    return this.http.post<any>(
      AppSettings.API_URI + '/payments/customer',
      { company_id: companyId },
      this.formHeaders
    );
  }
}
